// extracted by mini-css-extract-plugin
export var container = "_gn-1";
export var cornerButtonContainer = "_gn-6";
export var disabled = "_gn-2";
export var dragActive = "_gn-3";
export var fileContainer = "_gn-5";
export var hiddenInput = "_gn-4";
export var widthContainer = "_gn-0";